import Button from "@/components/Button";
import type { Action } from "@/components/MenuButton";
import { JobApplicationWithReviews } from "../../types";
import { exportApplicantReviewsCsv } from "./utils";

type ExportReviewsActionParams = {
  applications: JobApplicationWithReviews[];
  jobTitle: string;
  facilityName: string;
  disabled?: boolean;
};

export function buildExportReviewsAction({
  applications,
  jobTitle,
  facilityName,
  disabled
}: ExportReviewsActionParams): Action {
  return {
    text: "Export Reviews",
    variant: "outlined",
    iconName: "download",
    testId: "export-reviews-button",
    disabled,
    onClick: () => exportApplicantReviewsCsv(applications, jobTitle, facilityName)
  };
}

/**
 * Button to trigger a CSV download of a list of Job Applicants and their reviews. This CSV is compiled client-side.
 */
export default function ApplicantReviewsExportButton({
  applications = [],
  jobTitle = "Job Position",
  facilityName = "Unknown Facility"
}: ExportReviewsActionParams) {
  return (
    <Button
      icon="download"
      testId="export-reviews-button"
      variant="outlined"
      onClick={() => exportApplicantReviewsCsv(applications, jobTitle, facilityName)}
    >
      Export Reviews
    </Button>
  );
}
